import React, { Component } from "react";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import "./ExperienceAccordion.css";
import { Accordion, Panel } from "baseui/accordion";
import { experience } from "../../portfolio.js";

class ExperienceAccordion extends Component {
  render() {
    const theme = this.props.theme;
//    console.log("experience value is: ", JSON.stringify(experience.sections[0].experiences))
    const sections = experience["sections"]

//    console.log('sections["experiences"] value is: ', JSON.stringify(sections["experiences"]))

    return (
      <div className="accodian_set">
      <div>
      {experience.sections[0].experiences.map((experience_value,index) => {
                  return (
                    <ExperienceCard index={index} totalCards={experience.sections[0].experiences} experience={experience_value} theme={theme} />
                  );
                })}
      </div>

      {/* <div className="experience-accord">
        <Accordion>
          {this.props.sections.map((section) => {
            return (
              <Panel
                className="accord-panel"
                title={section["title"]}
                key={section["title"]}
                overrides={{
                  Header: {
                    style: () => ({
                      backgroundColor: `${theme.body}`,
                      border: `1px solid`,
                      borderRadius: `5px`,
                      borderColor: `${theme.headerColor}`,
                      marginBottom: `3px`,
                      fontFamily: "Google Sans Regular",
                      color: `${theme.text}`,
                      ":hover": {
                        color: `${theme.secondaryText}`,
                      },
                    }),
                  },
                  Content: {
                    style: () => ({
                      backgroundColor: `${theme.body}`,
                    }),
                  },
                }}
              >
{section["experiences"].map((experience,index) => {
                  return (
                    <ExperienceCard index={index} totalCards={section["experiences"].length} experience={experience} theme={theme} />
                  );
                })}
              </Panel>
            );
          })}
        </Accordion>
      </div> */}
      </div>
    );
  }
}

export default ExperienceAccordion;
